import { createFileRoute, redirect, useNavigate, useSearch } from '@tanstack/react-router';
import { FEATURE_FLAGS } from '@vizit/constants';
import { getFeatureFlag } from '@vizit/feature-flags';
import { parseAvcCallbackSearch, toAvcCallback } from '@vizit/organisms';
import * as React from 'react';
import { IntegrationsPage } from '../../../../pages';
import { PagesProvider } from '../../../../pages/providers/pages-provider';
import { beforeLoadAuthenticatedValidation } from '../../../../router';
import { NavbarPageTemplate } from '../../../../templates';

export const Route = createFileRoute('/_authenticated/w/$workspaceSlug/settings/integrations')({
  staticData: {
    pageName: 'Integrations',
  },
  validateSearch: parseAvcCallbackSearch,
  beforeLoad: async ({ context, location, params }) => {
    await beforeLoadAuthenticatedValidation(context, location);

    const isIntegrationsEnabled = await getFeatureFlag(FEATURE_FLAGS.INTEGRATIONS, false);
    if (!isIntegrationsEnabled) {
      throw redirect({ to: '/w/$workspaceSlug', params: { workspaceSlug: params.workspaceSlug } });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const search = useSearch({ from: Route.id });
  const navigate = useNavigate({ from: Route.fullPath });

  const [initialCallback] = React.useState(() => toAvcCallback(search));

  React.useEffect(() => {
    if (search.avc || search.id || search.reason) {
      void navigate({ search: {}, replace: true });
    }
  }, [search.avc, search.id, search.reason, navigate]);

  return (
    <PagesProvider template={NavbarPageTemplate}>
      <IntegrationsPage avcCallback={initialCallback} />
    </PagesProvider>
  );
}
